module.exports = __webpack_public_path__ + "static/media/office3.0909ee9f.jpg";